module.exports = __webpack_public_path__ + "static/media/newsImage3.5f542978.png";